import React, { useEffect, useRef } from 'react';

import { useDrag } from 'react-dnd';

import { ReactComponent as Times } from 'assets/icons/x.svg';

import './DraggableAnswer.scoped.scss';

interface IDraggableAnswer {
  title: string;
  id: string;
  number: number;
}

interface Props {
  answer: IDraggableAnswer;
  removeAnswer: (id: string) => void;
  containerRef: React.MutableRefObject<any>;
  onComponentRender?: () => void;
  id: string;
}

const DraggableAnswer = (props: Props) => {
  const { answer, removeAnswer, onComponentRender, containerRef, id } = props;
  const ref = useRef();

  useEffect(() => {
    onComponentRender();
  }, []);

  const [, drag] = useDrag(() => ({
    type: 'answer',
    item: ref,
  }));
  drag(ref);

  const removeThisAnswer = () => {
    containerRef.current.appendChild(ref.current);
    removeAnswer(answer.id);
  };

  return (
    <span id={id} className="answer-container" ref={ref} contentEditable="false">
      {answer.title}
      <div className="remove-button" onClick={removeThisAnswer}>
        <Times width={15} height={15} color="white" />
      </div>
    </span>
  );
};

export default DraggableAnswer;
